import { render, staticRenderFns } from "./IconAward.vue?vue&type=template&id=1201999b&"
import script from "./IconAward.vue?vue&type=script&lang=js&"
export * from "./IconAward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports